import fetch from 'isomorphic-fetch';

export const searchRequest = (payload) => {

  let params;

  if (window.location.search !== '') {
    delete payload.search;
    params = window.location.search + '&' + new URLSearchParams(payload).toString();
  } else {
    params = '?' + new URLSearchParams(payload).toString();
  }

  const url = window.location.host == 'localhost:3000' ? 'https://master-wordpress.rcoast.ru/wp-json/kaspersky/search' + params : 'https://os.kaspersky.ru/wp-json/kaspersky/search' + params;

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    // body: JSON.stringify(payload)
  };

  return fetch(url, {
    method: 'GET',
    headers,
  })
    .then(response => response.json())
    .then(data => data);

}